"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFruitOnArrival = function SvgFruitOnArrival(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6)",
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.768 11.888.497-3.185c-.142-.37-.266-.652-.347-.773l-.077-.116a8 8 0 0 1-1.105-2.498l-.092-.368a.921.921 0 0 0-1.788 0l-.092.368A8 8 0 0 1 1.66 7.814l-.077.116A3.466 3.466 0 0 0 1 9.852v.898c0 .69.56 1.25 1.25 1.25h3c.183 0 .358-.039.518-.112z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.776 3.393C3.156 1.6 2.146.801.75 1M4 3.232C4.016 1.744 4.747 1 6.191 1 6.071 2.333 5.341 3.077 4 3.232zm11.6 7.825a7.636 7.636 0 0 0 0-10.8l-10.8 10.8a7.636 7.636 0 0 0 10.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.572 10.028a6.182 6.182 0 0 0 0-8.742l-8.743 8.742a6.182 6.182 0 0 0 8.743 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 9.223 9.77)",
    cx: 9.223,
    cy: 9.771,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 11.28 9.77)",
    cx: 11.28,
    cy: 9.771,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 13.338 8.742)",
    cx: 13.338,
    cy: 8.742,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 14.366 6.685)",
    cx: 14.366,
    cy: 6.685,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 14.366 4.628)",
    cx: 14.366,
    cy: 4.628,
    r: 1
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgFruitOnArrival);
var _default = exports["default"] = Memo;